import React, { useState, createContext, useContext } from 'react';
interface RegistrationContextType {
  isPopupOpen: boolean;
  openPopup: () => void;
  closePopup: () => void;
}
const RegistrationContext = createContext<RegistrationContextType | undefined>(undefined);
export const RegistrationProvider: React.FC<{
  children: ReactNode;
}> = ({
  children
}) => {
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const openPopup = () => setIsPopupOpen(true);
  const closePopup = () => setIsPopupOpen(false);
  return <RegistrationContext.Provider value={{
    isPopupOpen,
    openPopup,
    closePopup
  }} data-id="element-116">
      {children}
    </RegistrationContext.Provider>;
};
export const useRegistration = (): RegistrationContextType => {
  const context = useContext(RegistrationContext);
  if (context === undefined) {
    throw new Error('useRegistration must be used within a RegistrationProvider');
  }
  return context;
};